import { Model } from '../../domain';
import { InvalidLanguageError } from '../Errors/InvalidLanguageError';
export class LanguageValueObject extends Model {
  static validate(_ref) {
    let {
      language
    } = _ref;

    if (!LanguageValueObject.cultures.includes(language)) {
      throw InvalidLanguageError.create("[LanguageValueObject.validate] language(" + language + ")");
    }
  }

  static create(_ref2) {
    let {
      language
    } = _ref2;
    LanguageValueObject.validate({
      language
    });
    return new LanguageValueObject({
      language
    });
  }

  constructor(_ref3) {
    let {
      language
    } = _ref3;
    super();
    this._value = void 0;
    this._value = language;
  }

  value() {
    return this._value;
  }

  toJSON() {
    return {
      language: this.value()
    };
  }

}
LanguageValueObject.cultures = ['en', 'es', 'pt', 'de', 'fr', 'it', 'nl', 'pl'];